"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _languageDirectionAPI = require("../../services/languageDirectionAPI");
var _mediaQuery = _interopRequireDefault(require("../../styles/media-query"));
var _LocaleSelect = _interopRequireDefault(require("../locale-select/LocaleSelect"));
const StyledFooter = _styled.default.footer(_ref => {
  let {
    theme
  } = _ref;
  return (0, _mediaQuery.default)({
    borderTop: [`1px solid ${theme.colors.grey[400]}`, null, null, `1px solid ${theme.colors.grey[400]}`],
    a: {
      color: theme.colors.grey[500],
      textDecoration: 'none'
    },
    select: {
      color: theme.colors.grey[600]
    }
  });
});
const FooterContentWrapper = _styled.default.div((0, _mediaQuery.default)({
  alignItems: ['center', null, null, 'flex-start'],
  display: 'flex',
  flexDirection: ['column', null, null, 'row'],
  justifyContent: ['center', null, null, 'space-between'],
  padding: ['24px 40px', null, null, '24px 40px'],
  rowGap: '24px'
}));
const CopyrightAndLinks = _styled.default.div(_ref2 => {
  let {
    theme
  } = _ref2;
  return (0, _mediaQuery.default)({
    display: ['flex', null, null, 'flex'],
    flexDirection: ['row', null, null, 'row'],
    flexWrap: ['wrap-reverse', null, null, 'wrap-reverse'],
    fontSize: theme.fontSizes.xxxSmall,
    justifyContent: ['center', null, null, 'flex-start'],
    rowGap: '12px',
    width: 'fit-content'
  });
});
const CopyrightText = _styled.default.span(_ref3 => {
  let {
    theme
  } = _ref3;
  return (0, _mediaQuery.default)({
    color: theme.colors.grey[500],
    display: ['block', null, null, 'inline'],
    margin: ['0 auto', null, null, '0 24px 0 0'],
    textAlign: ['center', null, null, null],
    width: ['100%', null, null, 'fit-content']
  });
});
const ChildrenWrapper = _styled.default.div(_ref4 => {
  let {
    theme
  } = _ref4;
  return (0, _mediaQuery.default)({
    display: ['flex', null, null, null],
    flexWrap: ['wrap', null, null, null],
    justifyContent: ['center', null, null, null],
    '& a': {
      margin: '0 8px',
      position: 'relative',
      '&:not(:last-child):after': {
        content: '""',
        height: '12px',
        position: 'absolute',
        right: '-8px',
        top: '50%',
        transform: 'translateY(-50%)',
        width: '1px',
        backgroundColor: theme.colors.grey[400]
      },
      '&:first-child': {
        marginLeft: 0
      }
    }
  });
});

/**
 * A basic footer that has a link section and a locale select section.
 */
const Footer = _ref5 => {
  let {
    children,
    copyrightText,
    i18n
  } = _ref5;
  const {
    direction
  } = (0, _languageDirectionAPI.useLanguageDirection)();
  return /*#__PURE__*/_react.default.createElement(StyledFooter, {
    dir: direction
  }, /*#__PURE__*/_react.default.createElement(FooterContentWrapper, null, /*#__PURE__*/_react.default.createElement(CopyrightAndLinks, null, /*#__PURE__*/_react.default.createElement(CopyrightText, null, copyrightText), /*#__PURE__*/_react.default.createElement(ChildrenWrapper, null, children)), /*#__PURE__*/_react.default.createElement(_LocaleSelect.default, {
    i18n: i18n
  })));
};
var _default = exports.default = Footer;